'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var desktop_Component_desktop = require('./Component.desktop.js');



exports.CustomButtonDesktop = desktop_Component_desktop.CustomButtonDesktop;
